<template>
    <div class="weixinShare" v-if="isShow" @click="closeTip">
        <div class="weixinShareCon">
            <div class="weixinShare-img">
                <img src="../../assets/wxShareArrowIcon.png">
            </div>
            <div class="weixinShare-txt">
                <p>点击右上角</p>
                <p>将它分享给朋友</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ShareTip',
    data () {
        return  {
            isShow: false
        }
    },
    methods: {
        closeTip () {
            this.isShow = false
        }
    }
}
</script>
<style lang="less" scoped>
    /**** 微信分享遮罩层 ****/
    .weixinShare {
        position: fixed;
        top: -41px;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.6);
        z-index: 10009;
        .weixinShareCon {
            position:relative;
            width:100%;
            height:100%;
            .weixinShare-img {
                width:118px;
                height:172px;
                position:absolute;
                top:44px;
                right:40px;
                img{
                    width:100%;
                }
            }
            .weixinShare-txt {
                position:absolute;
                top:20%;
                left:0;
                width:100%;
                height:40%;
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                p {
                    margin-top: 0;
                    margin-bottom: 2px;
                    font-size: 17px;
                    font-style: italic;
                    color:#fff;
                }
            }
        }
    }
</style>
